// extracted by mini-css-extract-plugin
module.exports = {"input":"InputForSearch_input__3MjL7","input-wrapper":"InputForSearch_input-wrapper__3JPwW"};